/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable } from '@angular/core'
import { registerLocaleData } from '@angular/common'
import { Observable, of, throwError } from 'rxjs'

// Locale-Daten importieren
import localeCs from '@angular/common/locales/cs'
import localeDa from '@angular/common/locales/da'
import localeDe from '@angular/common/locales/de'
import localeEnGB from '@angular/common/locales/en-GB'
import localeEn from '@angular/common/locales/en'
import localeEs from '@angular/common/locales/es'
import localeEt from '@angular/common/locales/et'
import localeFi from '@angular/common/locales/fi'
import localeFr from '@angular/common/locales/fr'
import localeIt from '@angular/common/locales/it'
import localeJa from '@angular/common/locales/ja'
import localeKo from '@angular/common/locales/ko'
import localeLt from '@angular/common/locales/lt'
import localeLv from '@angular/common/locales/lv'
import localeNl from '@angular/common/locales/nl'
import localeNn from '@angular/common/locales/nn'
import localeNb from '@angular/common/locales/nb'
import localePl from '@angular/common/locales/pl'
import localePt from '@angular/common/locales/pt'
import localeRu from '@angular/common/locales/ru'
import localeSv from '@angular/common/locales/sv'
import localeTr from '@angular/common/locales/tr'
import localeZhHans from '@angular/common/locales/zh-Hans'
import localeZhHant from '@angular/common/locales/zh-Hant'

@Injectable()
export class CustomLocaleLoaderService {
  private readonly localeMap: Record<string, any> = {
    cs: localeCs,
    da: localeDa,
    de: localeDe,
    'en-GB': localeEnGB,
    en: localeEn,
    es: localeEs,
    et: localeEt,
    fi: localeFi,
    fr: localeFr,
    it: localeIt,
    ja: localeJa,
    ko: localeKo,
    lt: localeLt,
    lv: localeLv,
    nl: localeNl,
    nn: localeNn,
    nb: localeNb,
    pl: localePl,
    pt: localePt,
    ru: localeRu,
    sv: localeSv,
    tr: localeTr,
    'zh-Hans': localeZhHans,
    'zh-Hant': localeZhHant,
  }

  load(locale: string): Observable<string> {
    const localeData = this.localeMap[locale]

    if (!localeData) {
      return throwError(() => new Error(`Locale "${locale}" is not supported.`))
    }

    registerLocaleData(localeData)
    return of(locale)
  }
}
